module.exports = __webpack_public_path__ + "img/mail.48626f03.svg";